import type {
  ParticipantId,
  StoneFlickingCoreState,
} from "@cloudnest/stone-flicking-core-engine/types";
import type { PlayerId } from "../types/common";
import type { GamePhase, StoneFlickingState } from "../types/game-state";

const PLAYER_IDS: ReadonlyArray<PlayerId> = ["P1", "P2", "P3", "P4"];

export function toParticipantId(playerId: PlayerId): ParticipantId {
  return playerId;
}

export function toPlayerId(participantId: ParticipantId): PlayerId {
  if (PLAYER_IDS.includes(participantId as PlayerId)) {
    return participantId as PlayerId;
  }
  throw new Error(`Unknown participant id: ${participantId}`);
}

function mapPhase(corePhase: StoneFlickingCoreState["phase"]): GamePhase {
  if (corePhase === "INPUT_PHASE") return "PLAYING";
  if (corePhase === "RESOLVING") return "RESOLVING";
  return "GAME_END";
}

export function wrapCoreState(
  coreState: StoneFlickingCoreState,
): StoneFlickingState {
  return {
    phase: mapPhase(coreState.phase),
    coreState,
    round: coreState.round,
    playerCount: coreState.participants.length,
    eliminatedPlayers: coreState.eliminatedParticipants.map(toPlayerId),
    submittedPlayers: coreState.submittedParticipants.map(toPlayerId),
    winner: coreState.winner ? toPlayerId(coreState.winner) : null,
    isDraw: coreState.isDraw,
  };
}
